import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['select', 'submit', 'showForm']

  showForm(event) {
    if(!this.element.classList.contains('form-is-visible')) {
      this.element.classList.toggle('form-is-visible')
      this.selectTarget.focus()
    }
  }

  onAjaxComplete(event) {
    document.dispatchEvent(new Event('user-shoe:created'))
    this.element.classList.remove('form-is-visible')
    this.showFormTarget.innerHTML = this.selectTarget.selectedOptions[0].value
  }
}
